/**
 * Shared by Input and Select so their control metrics, background/text pair
 * and focus/error treatment can never drift apart.
 *
 * These classes are deliberately kept OUT of the `cn()` merge chain that
 * accepts a caller's `className` — see the ui README's "Do not override
 * Input/Select colours" section for why. `className` on Input/Select is for
 * layout only (width, margin) and is applied to a wrapper element instead.
 */
export const FIELD_BASE_CLASSES =
    'h-8 w-full rounded-control px-3 bg-space-950 border border-space-600 text-body text-content-primary placeholder:text-content-muted disabled:opacity-40 disabled:cursor-not-allowed';

export const FIELD_FOCUS_CLASSES =
    'focus-visible:outline-none focus-visible:border-hairline-strong focus-visible:ring-2 focus-visible:ring-hairline-strong/40';

export const FIELD_ERROR_BORDER_CLASSES = 'border-status-danger';

export const FIELD_LABEL_CLASSES = 'block text-label text-content-secondary mb-1';

export const FIELD_HINT_CLASSES = 'mt-1 text-micro text-content-muted';

export const FIELD_ERROR_TEXT_CLASSES = 'mt-1 text-micro text-status-danger';
